<template>
  <div class="login-content">
    <slot />
  </div>
</template>

<script lang="ts" setup>

</script>

<style>
.login-content {
  min-height: 100vh;
  width: 100%;
}
</style>
